import { useState, useCallback, useRef } from 'react';

import StepByStepForm from './StepByStepForm/StepByStepForm';
import JsonForm from './JsonForm/JsonForm';

import { type IProfileForm } from './@interfaces';
import { type TParsedCategoryTree } from '../../../modules/profile/shared/transformations/form/@interfaces';

import styles from './ProfileForm.module.scss';

export const ProfileForm = ({
  categoryTree,
  formContent,
  _isVersionB = false,
}: IProfileForm) => {
  const formRef = useRef(null);

  const [category, setCategory] = useState(() => {
    if (categoryTree.children) {
      return null;
    }

    return categoryTree;
  });

  const handleOnSelectedItem = useCallback((item: TParsedCategoryTree) => {
    setCategory(item);
  }, []);

  return (
    <div
      id="form"
      className={`category-form ${styles['category-form']} `}
      tabIndex={-1}
      ref={formRef}
    >
      {!category ? (
        <StepByStepForm
          ref={formRef}
          categoryTree={categoryTree}
          onSelectedItem={handleOnSelectedItem}
        />
      ) : (
        <JsonForm category={category} formContent={formContent} _isVersionB={_isVersionB} />
      )}

      <div
        className={`category-form__deadline-info ${styles['category-form__deadline-info']} `}
      >
        Orçamentos em até 60 minutos
      </div>
    </div>
  );
};
